module.exports = __webpack_public_path__ + "img/graphic-1.f0456816.png";